export const formIds = {
	INLAND_MARINE: '0bb25529-baaf-4b5c-b548-93fd2c4b7944',
	COMMERCIAL_PROPERTY: '2adf1dfe-2b9f-484d-a66d-19d43837f1ed',
	COMMERCIAL_CRIME: '68a7d8ea-872d-48ee-b716-0c40a90d7d19',
	GENERAL_LIABILITY: '1fd6f227-e6ec-4a56-8d02-58eb9c4ebe57',
	GENERAL_INFORMATION: '16813bad-3c5f-4a5a-b62d-2bff644aa97a',
	GENERAL_INFORMATION_AMENDED: '66a7d302-a311-419b-9442-e35ba5b8f60c',
	CYBER_COVERAGE_QUESTIONNAIRE: '5651cb24-22b3-4f0c-876e-690b2c6088b7'
};
